import { render, staticRenderFns } from "./NFSeShow.vue?vue&type=template&id=68f0d3b2&scoped=true"
import script from "./NFSeShow.vue?vue&type=script&lang=js"
export * from "./NFSeShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f0d3b2",
  null
  
)

export default component.exports